import React from 'react'
import PropTypes from 'prop-types'
import WrappedModal from '@/components/WrappedModal'
import DispatchForm from './DispatchForm'

class DispatchModal extends React.Component {
  modalRef = React.createRef()

  state = {
    appointment: null
  }

  static propTypes = {
    startOptions: PropTypes.array,
    date: PropTypes.string,
    idleTechnicianOptions: PropTypes.func,
    onSuccess: PropTypes.func
  }

  show = (appointment) => {
    this.setState({ appointment }, () => {
      this.modalRef.current?.showModal?.({ stopPropagation: () => {} })
    })
  }

  handleOk = async (form) => {
    const { onSuccess } = this.props
    const { appointment } = this.state
    const fields = await form.current.validateFields()
    if (typeof onSuccess !== 'function') return
    if (!appointment) throw new Error('missing appointment')
    await onSuccess({
      id: appointment.id,
      durationMinutes: appointment.durationMinutes,
      ...fields
    })
  }

  render () {
    const { startOptions, date, idleTechnicianOptions } = this.props
    const { appointment } = this.state
    return (
      <WrappedModal
        ref={this.modalRef}
        title="派单"
        okText="派上"
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={480}
        zIndex={1100}
        baseComponent={<DispatchForm />}
        baseProps={{ appointment, startOptions, date, idleTechnicianOptions }}
        onOk={this.handleOk}
      />
    )
  }
}

export default DispatchModal
